import axios from 'axios';

export default axios.create({
  baseURL: 'https://api.77experts.com',
  // 'http://env-4413506.jelastic.regruhosting.ru/',
  // 'https://api.wakeyourhrup.77experts.com/',
});
